import styles from './quiz-info-template.module.scss';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

type QuizInfoTemplateProps = {
    children: React.ReactNode;
    fixedFooterContent?: React.ReactNode;
    contentWrapperClassName?: string;
    contentClassName?: string;
    wrapperClassName?: string;
    footerClassName?: string;
};
const QuizInfoTemplate = ({
    children,
    contentWrapperClassName,
    contentClassName,
    wrapperClassName,
}: QuizInfoTemplateProps) => {
    const contentRef = useRef<HTMLDivElement | null>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    // Check if content overflowing to allow different styles
    useEffect(() => {
        const { current } = contentRef;
        const { clientHeight, scrollHeight } = current || {};
        if (current && scrollHeight && clientHeight) {
            const hasOverflow = scrollHeight > clientHeight;
            setIsOverflowing(hasOverflow);
        }
    }, [contentRef]);

    return (
        <div
            className={classNames(
                styles['quiz-info-template-wrapper'],
                wrapperClassName ? wrapperClassName : '',
            )}
        >
            <div className="container">
                <div className={styles['quiz-info-template']}>
                    <div
                        ref={contentRef}
                        className={classNames(
                            styles['content-wrapper'],
                            isOverflowing ? styles['content-overflowing'] : '',
                            contentWrapperClassName
                                ? contentWrapperClassName
                                : '',
                        )}
                    >
                        <div
                            className={classNames(
                                styles['content'],
                                contentClassName ? contentClassName : '',
                            )}
                        >
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuizInfoTemplate;
